import * as actionTypes from '../actions/actionTypes';
import * as actions from './index';

export const updateConfigObjectsSuccess = (data) => {
    return {
        type: actionTypes.CONFIG_UPDATE_CONFIGOBJECTS_SUCCESS,
        payload: data
    }
}

export const updateConfigObjects = (obj) => {
    return (dispatch) => {
        dispatch(actions.updateConfigObjectsSuccess(obj));
    }
}
